import { tss } from 'tss-react/mui';

export const useControlBarStyles = tss.create(({ theme }) => ({
  container: {
    position: 'relative',
    height: '72px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 24px',
    backgroundColor: theme.palette.background.paper,
    borderTop: `1px solid ${theme.palette.border.subtle}`,
  },
  controlsContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '16px',
  },
  micButton: {
    width: '42px',
    height: '42px',
    borderRadius: '50%',
    transition: 'all 0.15s ease',
    boxShadow: 'none',
    '& .MuiSvgIcon-root': {
      fontSize: '20px',
    },
    '&:hover': {
      boxShadow: 'none',
    },
  },
  micButtonActive: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: theme.palette.success.dark,
    },
  },
  micButtonMuted: {
    backgroundColor: theme.palette.status.danger.background,
    color: theme.palette.error.main,
    border: `1.5px solid ${theme.palette.status.danger.border}`,
    '&:hover': {
      backgroundColor: theme.palette.error.light,
    },
  },
  endCallButton: {
    padding: '8px 24px',
    borderRadius: '24px',
    fontSize: '14px',
    fontWeight: 600,
    textTransform: 'none' as const,
    minWidth: '130px',
    boxShadow: 'none',
    backgroundColor: theme.palette.error.main,
    transition: 'all 0.15s ease',
    '& .MuiSvgIcon-root': {
      fontSize: '18px',
    },
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: theme.palette.status.danger.foreground,
    },
  },
  connectingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
  },
  loadingDot: {
    width: '6px',
    height: '6px',
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    animation: '$pulse 1.5s ease-in-out infinite',
  },
  connectingText: {
    color: theme.palette.text.secondary,
    fontWeight: 500,
    fontSize: '14px',
  },
  '@keyframes pulse': {
    '0%, 100%': {
      opacity: 0.4,
      transform: 'scale(1)',
    },
    '50%': {
      opacity: 1,
      transform: 'scale(1.2)',
    },
  },
}));
